import React from 'react';

export default function Hero() {
  return (
    <div className="hero-container" style={{ position: 'relative', left: 0, right: 0, marginLeft: 0, marginRight: 0, width: '100vw', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', marginTop: 0, padding: 0 }}>
      <h1 style={{ position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>Bokeh – Unique Clothing, Jewelry & Custom Cut-and-Sew</h1>
      <p style={{ position: 'absolute', width: 1, height: 1, padding: 0, margin: -1, overflow: 'hidden', clip: 'rect(0,0,0,0)', whiteSpace: 'nowrap', border: 0 }}>Shop unique clothing, archive clothing, vintage apparel, jewelry, and custom cut-and-sew. Custom commissions and handcrafted fashion.</p>
      <img
        src="/hero.jpg"
        alt="Bokeh – Unique clothing, jewelry, and custom cut-and-sew. Vintage-inspired fashion and accessories."
        style={{ width: '100vw', height: 'auto', display: 'block', margin: 0, padding: 0 }}
        loading="eager"
        fetchpriority="high"
      />
      <style>{`
        /* Responsive Hero */
        @media (max-width: 768px) {
          .hero-container {
            height: 500px !important;
          }
          .hero-container img {
            width: 100vw !important;
            height: 500px !important;
            object-fit: cover !important;
            object-position: center !important;
          }
        }
        
        @media (max-width: 480px) {
          .hero-container {
            height: 400px !important;
          }
          .hero-container img {
            width: 100vw !important;
            height: 400px !important;
            object-fit: cover !important;
            object-position: center !important;
          }
        }
      `}</style>
    </div>
  );
} 